import { render } from "./InstanceEdit.vue?vue&type=template&id=5b3de450"
import script from "./InstanceEdit.vue?vue&type=script&lang=js"
export * from "./InstanceEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__